module.exports = __webpack_public_path__ + "static/media/img19.0adfb1d7.jpg";